module.exports = __webpack_public_path__ + "static/media/bulb-icon.28a44f6c.svg";